import { render, staticRenderFns } from "./AddVpnInfoDialog.vue?vue&type=template&id=5651fb4f&scoped=true&"
import script from "./AddVpnInfoDialog.vue?vue&type=script&lang=js&"
export * from "./AddVpnInfoDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5651fb4f",
  null
  
)

export default component.exports